import React from 'react';
import { Form, InputNumber } from 'antd';
import styles from './CharacterSheetModal.module.css';

const CharacterSheetStats: React.FC = () => {
  const stats = ['str', 'dex', 'con', 'int', 'wis', 'cha'];

  return (
    <div className={styles.stats}>
      {(stats ?? []).map(stat => (
        <div key={stat} className={styles.statBlock}>
          <div className={styles.statName}>{stat.toUpperCase()}</div>
          <Form.Item name={['stats', stat]} noStyle>
            <InputNumber className={styles.statValueInput} />
          </Form.Item>
        </div>
      ))}
    </div>
  );
};

export default CharacterSheetStats;